import React from "react";

const BodySketchFace = () => (
  <g
    transform="translate(-170,680) scale(0.093,-0.093)"
    fill="#000000"
    stroke="none"
    className="body"
  >
    <path
      d="M5265 6145 c-283 -56 -345 -75 -345 -104 0 -21 -18 -31 -59 -31 -15
0 -38 -9 -51 -20 -13 -11 -27 -20 -33 -20 -18 0 -132 -89 -189 -147 -131 -135
-302 -374 -383 -533 -18 -34 -65 -207 -65 -236 0 -9 -7 -31 -16 -50 -9 -19
-14 -46 -11 -61 3 -16 7 -35 9 -43 1 -8 -1 -68 -6 -132 -5 -77 -4 -128 3 -150
6 -18 17 -100 26 -183 9 -82 22 -172 30 -200 24 -89 23 -98 -21 -148 -49 -55
-75 -135 -81 -247 -11 -174 98 -527 192 -623 19 -19 52 -43 74 -53 22 -11 43
-26 45 -34 3 -8 19 -89 36 -180 36 -187 80 -339 139 -484 40 -98 41 -101 41
-225 0 -141 -21 -348 -46 -447 -40 -158 -176 -260 -669 -504 -305 -151 -519
-248 -740 -337 -88 -35 -198 -85 -245 -110 -115 -63 -213 -112 -350 -176 -175
-82 -287 -178 -366 -313 -24 -41 -100 -250 -118 -327 -6 -26 -5 -28 20 -25 24
3 29 12 68 133 52 162 84 221 165 307 82 88 170 146 324 213 69 30 169 80 223
111 107 60 156 82 365 167 297 120 908 417 1088 528 112 69 232 184 260 249
36 83 62 266 68 475 l5 190 -50 125 c-64 160 -94 268 -138 488 -19 97 -40 183
-47 189 -7 7 -33 23 -57 35 -83 43 -147 162 -202 378 -58 232 -46 370 41 463
41 44 46 54 44 91 -1 23 -8 67 -17 97 -8 30 -22 119 -31 199 -8 80 -20 168
-26 195 -7 34 -8 84 -2 155 6 60 6 119 1 137 -6 20 -5 40 1 51 9 17 26 85 52
211 19 91 190 351 363 553 68 79 167 161 223 184 17 8 34 18 38 24 3 5 16 10
29 10 42 0 86 21 92 44 5 23 41 35 194 66 25 5 79 16 120 25 91 20 104 20 159
0 50 -17 107 -20 116 -5 4 7 11 7 18 2 24 -18 76 -21 138 -6 79 19 148 20 262
7 77 -9 93 -14 125 -42 20 -18 71 -48 112 -68 41 -20 100 -53 130 -73 30 -21
78 -52 107 -69 118 -73 362 -376 434 -539 56 -129 71 -219 72 -437 0 -288 -31
-597 -73 -727 l-22 -66 35 -51 c47 -67 78 -152 84 -226 9 -98 -66 -386 -134
-516 -51 -98 -78 -120 -155 -126 l-64 -5 -23 -117 c-12 -64 -39 -188 -59 -276
-35 -154 -36 -167 -34 -334 2 -195 14 -335 42 -461 63 -292 131 -346 935 -750
336 -169 472 -232 735 -340 217 -89 258 -110 410 -210 329 -217 442 -343 523
-585 21 -61 27 -70 50 -73 15 -2 27 -2 27 0 0 3 -13 42 -29 89 -38 114 -100
233 -155 301 -56 68 -206 191 -364 296 -166 111 -222 140 -442 230 -255 104
-399 171 -737 341 -563 284 -704 367 -803 479 -84 94 -123 255 -141 584 -10
182 -9 215 5 285 9 43 36 170 60 283 l42 205 58 12 c123 24 191 140 271 463
41 161 43 231 12 332 -14 46 -40 105 -58 133 l-31 49 15 51 c47 151 85 636 68
860 -13 166 -25 220 -72 328 -45 101 -85 164 -201 309 -110 140 -189 215 -284
272 -43 27 -91 59 -106 71 -15 13 -53 33 -85 45 -31 11 -72 35 -92 52 -53 47
-108 68 -178 68 -35 0 -65 5 -69 11 -9 15 -132 5 -215 -16 -52 -14 -62 -14
-95 0 -44 18 -71 19 -77 3 -3 -10 -14 -10 -53 1 -68 20 -127 22 -209 6z"
    />
  </g>
);

export default BodySketchFace;
